import { Accordion } from "react-bootstrap";
import parse from 'html-react-parser';
const { useSafariPackagesContext } = require("provider/SharePackagesProvider");


const Itinerary = () => {
    const { packageViewData } = useSafariPackagesContext();
    return (
        <>
            <div className="card bg-set accordion-collapse  card_bodyPadding">
                <div className="card-body p-3">
                    <div className="itenary-title">
                        <h6 className="fs-6 fw-bold mb-4">ITINERARY</h6>
                    </div>
                    <div className="itenary_text"></div>
                    <div className="row pt-lg-4 pt-4">
                        <div className="col-12 inner_accordion">
                            <Accordion defaultActiveKey="" flush id="accordionFlushExample">
                                {packageViewData?.package_days?.length > 0 ? (
                                    packageViewData?.package_days.map((packageday, index) => (
                                        <Accordion.Item
                                            key={index}
                                            eventKey={index.toString()}
                                            className="accordion-item mb-3"
                                        >
                                            <Accordion.Header className="accordion-header">
                                                DAY {packageday.day} - {packageday.day_title}
                                            </Accordion.Header>
                                            <Accordion.Body>
                                                <div className="wrap_days">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="text_wrapperite">
                                                                {packageday.day_description && parse(packageday.day_description)}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {(packageday.start_location ||
                                                        packageday.end_location ||
                                                        packageday.hotel_name) && (
                                                            <div className="row pt-3">
                                                                {packageday.start_location && (
                                                                    <div className="col-lg-4 mb-3">
                                                                        <div className="titles_locations">
                                                                            <h6 className="fs-5">Start Location</h6>
                                                                            <p>{packageday.start_location}</p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {packageday.end_location && (
                                                                    <div className="col-lg-4 mb-3">
                                                                        <div className="titles_locations">
                                                                            <h6 className="fs-5">End Location</h6>
                                                                            <p>{packageday.end_location}</p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                {packageday.hotel_name && (
                                                                    <div className="col-lg-4 mb-3">
                                                                        <div className="titles_locations">
                                                                            <h6 className="fs-5">Hotel Stay</h6>
                                                                            <p>{packageday.hotel_name}</p>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}

                                                    {(packageday.meal_breakfast ||
                                                        packageday.meal_lunch ||
                                                        packageday.meal_dinner) && (
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="titles_locations">
                                                                        <h6 className="fs-5">Meals</h6>
                                                                        <div className="mealchecks d-flex gap-sm-4 gap-2 align-items-center flex-wrap">
                                                                            {packageday.meal_breakfast === 1 && (
                                                                                <div className="inputsCheck mb-2 d-flex align-items-center gap-2">
                                                                                    <input type="checkbox" checked readOnly />
                                                                                    <label>Breakfast</label>
                                                                                </div>
                                                                            )}
                                                                            {packageday.meal_lunch === 1 && (
                                                                                <div className="inputsCheck mb-2 d-flex align-items-center gap-2">
                                                                                    <input type="checkbox" checked readOnly />
                                                                                    <label>Lunch</label>
                                                                                </div>
                                                                            )}
                                                                            {packageday.meal_dinner === 1 && (
                                                                                <div className="inputsCheck mb-2 d-flex align-items-center gap-2">
                                                                                    <input type="checkbox" checked readOnly />
                                                                                    <label>Dinner</label>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))
                                ) : (
                                    <p>No itinerary details available.</p>
                                )}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row pt-lg-4 pt-4">
                <div className="col-12 inner_accordion">
                    <Accordion
                        defaultActiveKey=""
                        flush
                        id="accordionFlushExample"
                    >
                        {/* {packageViewData?.package_days?.length > 0 ? (
                          packageViewData?.package_days.map(
                            (packageday, index) => (
                              <Accordion.Item
                                key={index}
                                eventKey={index.toString()}
                                className="accordion-item mb-3"
                              >
                                <Accordion.Header
                                  className="accordion-header"
                                  id={`flush-heading${packageday.day}`}
                                >
                                  DAY {packageday.day} - {packageday.day_title}
                                </Accordion.Header>
                                <Accordion.Body>
                                  <div className="wrap_days">
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="text_wrapperite">
                                     
                                        </div>
                                      </div>
                                    </div>

                                    {(packageday.start_location ||
                                      packageday.end_location ||
                                      packageday.hotel_name) && (
                                      <div className="row pt-3">
                                        {packageday.start_location && (
                                          <div className="col-lg-4 mb-3">
                                            <div className="titles_locations">
                                              <h6 className="fs-5">
                                                Start Location
                                              </h6>
                                              <p>{packageday.start_location}</p>
                                            </div>
                                          </div>
                                        )}
                                        {packageday.end_location && (
                                          <div className="col-lg-4 mb-3">
                                            <div className="titles_locations">
                                              <h6 className="fs-5">
                                                End Location
                                              </h6>
                                              <p>{packageday.end_location}</p>
                                            </div>
                                          </div>
                                        )}
                                        {packageday.hotel_name && (
                                          <div className="col-lg-4 mb-3">
                                            <div className="titles_locations">
                                              <h6 className="fs-5">
                                                Hotel Stay
                                              </h6>
                                              <p>{packageday.hotel_name}</p>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    {(packageday.meal_breakfast ||
                                      packageday.meal_lunch ||
                                      packageday.meal_dinner) && (
                                      <div className="row">
                                        <div className="col-12">
                                          <div className="titles_locations">
                                            <h6 className="fs-5">Meals</h6>
                                            <div className="mealchecks d-flex gap-sm-4 gap-2 align-items-center flex-wrap">
                                              {packageday.meal_breakfast ===
                                                1 && (
                                                <div className="inputsCheck mb-2 d-flex align-items-center gap-2">
                                                  <input
                                                    type="checkbox"
                                                    checked
                                                    readOnly
                                                  />
                                                  <label>Breakfast</label>
                                                </div>
                                              )}
                                              {packageday.meal_lunch === 1 && (
                                                <div className="inputsCheck mb-2 d-flex align-items-center gap-2">
                                                  <input
                                                    type="checkbox"
                                                    checked
                                                    readOnly
                                                  />
                                                  <label>Lunch</label>
                                                </div>
                                              )}
                                              {packageday.meal_dinner === 1 && (
                                                <div className="inputsCheck mb-2 d-flex align-items-center gap-2">
                                                  <input
                                                    type="checkbox"
                                                    checked
                                                    readOnly
                                                  />
                                                  <label>Dinner</label>
                                                </div>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    {packageday.latitude &&
                                      packageday.longitude && (
                                        <div className="row pt-3">
                                          <div className="col-lg-6 mb-3">
                                           
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            )
                          )
                        ) : (
                          <p>No package details available.</p>
                        )} */}
                    </Accordion>
                </div>
            </div>
        </>
    )
}

export default Itinerary;